<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="card">
        <div class="card-body tab2-card">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                  <a ngbNavLink>External Channel Mapping</a>
                  <ng-template ngbNavContent>
                    <form [formGroup]="checkoutForm"  class="needs-validation" novalidate="" (ngSubmit)="onSubmit()">
                        <div class="form-group row align-items-center">
                            <div class="col-xl-3 col-md-4"><label for="validationCustom0"><span>*</span>Channel List</label></div>
                            <div class="col-xl-8 col-md-7">
                                <div cdkDropListGroup>
                                    <div class="example-container" >
                                      <h2>DRAG</h2>
                                      <div
                                        cdkDropList
                                        [cdkDropListData]="todo"
                                        class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of todo" cdkDrag>{{item.name}}</div>
                                      </div>
                                    </div>
                                    <div class="example-container" >
                                      <h2>DROP</h2>
                                      <div
                                        cdkDropList
                                        [cdkDropListData]="done"
                                        class="example-list"
                                        formControlName="name"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of done" cdkDrag >{{item.name}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                             <div class="col-xl-3 col-md-4"><label for="validationCustom0"><span>*</span>User List</label></div>
                            <div class="col-xl-8 col-md-7">
                                <select class="form-select form-control" formControlName="userid">
                                    <option *ngFor="let item of username" [value]='item.id'>{{item.username}}</option>
                                  </select>
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </form>
                  </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
            
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->